import styles from './changelog.module.less';

import type {Change, CriticalityLevel} from '@graphql-inspector/core';

function groupByCriticality(changelog: Change[]) {
    return changelog.reduce(
        (acc: Record<CriticalityLevel, Change[]>, item: Change) => {
            acc[item.criticality.level].push(item);
            return acc;
        },
        {
            BREAKING: [],
            DANGEROUS: [],
            NON_BREAKING: [],
        },
    );
}

type ChangelogListProps = {
    title: string;
    changes: Change[];
    scrollId: string;
};

const changeTitleMap = {
    BREAKING: 'Breaking Changes',
    DANGEROUS: 'Potentially Dangerous Changes',
    NON_BREAKING: 'Non-Breaking Changes',
};

export const ChangelogList = ({changes, title, scrollId}: ChangelogListProps) => {
    const groups = groupByCriticality(changes);
    return (
        <div className={styles['changelog-list-container']} id={scrollId}>
            <h3 className="ud-heading-serif-xl">{title}</h3>
            <br />
            {Object.entries(groups).map((entry, groupIndex: number) => {
                const [criticality, items] = entry;
                // If there are no changes, don't render the list
                if (items.length === 0) return null;
                return (
                    <div key={groupIndex}>
                        <h4 className="ud-heading-serif-lg">
                            {changeTitleMap[criticality as CriticalityLevel]}
                        </h4>
                        <ul>
                            {(items as Change[]).map((item: Change, changeIndex) => (
                                <li key={changeIndex}>{item.message}</li>
                            ))}
                        </ul>
                    </div>
                );
            })}
        </div>
    );
};
